// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-form-field {
   display: block;
   margin: 0 10px;
   width: 300px;
}

password-strength {
   margin: 0 10px;
}

.error {
   font-size: 13px;
   text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/app/e-signature/register-signature/change-pass-sign/change-pass-sign.component.css"],"names":[],"mappings":"AAAA;GACG,cAAc;GACd,cAAc;GACd,YAAY;AACf;;AAEA;GACG,cAAc;AACjB;;AAEA;GACG,eAAe;GACf,kBAAkB;AACrB","sourcesContent":[".mat-form-field {\n   display: block;\n   margin: 0 10px;\n   width: 300px;\n}\n\npassword-strength {\n   margin: 0 10px;\n}\n\n.error {\n   font-size: 13px;\n   text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
